import React from 'react';
import { IconFilter } from './Icons';

export function FilterSubmitButton({ onClick, disabled, className = '' }) {
  return (
    <button
      type="button"
      className={`btn btn-filter-warm w-100 d-inline-flex align-items-center justify-content-center gap-2 ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
      aria-label="Apply filters"
    >
      <IconFilter size={18} strokeWidth={2} className="flex-shrink-0" />
      <span>Filter</span>
    </button>
  );
}
